import React, { } from 'react';

const SearchBar = ({ pendingSearchTerm, handleSearchChange = () => { }, handleSearchKeyPress = () => { }, optionalInfos = [] }) => {
    return (
        <div className="search-bar">
            <input
                type="text"
                placeholder="Search..."
                value={pendingSearchTerm} // Controlled by pendingSearchTerm
                onChange={handleSearchChange} // Update pending search term
                onKeyDown={handleSearchKeyPress} // Trigger search only on Enter
            />
            {/* Display Stats */}
            <div className="model-stats">
                ({optionalInfos})
            </div>

        </div>
    );

};

export default SearchBar;
